import {
  styled,
  TextField,
  IconButton,
  Paper,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Box,
  Tab,
  useMediaQuery,
  DialogActions,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./gallery_details.css";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Event1 from "../../../images/event1.jpg";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ArrowBack, ArrowForward, Close, Download } from "@mui/icons-material";
import getEventController from "../Controller/getEvent_controller";

const EventGallery = () => {
  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation();
  const isLargeScreen = useMediaQuery("(min-width:640px)");
  const { eventId } = location.state; // Access passed data
  const { title } = location.state; // Access passed data
  // console.log(eventId);
  // console.log(title);

  const [spacing, setSpacing] = React.useState(2);

  const [open, setOpen] = React.useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [selectedImg, setSelectedImg] = React.useState(null);
  const [eventItemData, setEventItemData] = useState([]);

  useEffect(() => {
    getEventController
      .getEventItembyEventId(eventId)
      .then((response) => {
        console.log("API Response:", response); // Debugging log

        if (Array.isArray(response)) {
          setEventItemData(formatEvents(response));
        } else {
          console.error("API response is not an array:", response);
          setEventItemData([]); // Prevent .map() errors
        }
      })
      .catch((error) => {
        console.error("Error fetching event item:", error);
        setEventItemData([]);
      });
  }, []);

  const formatEvents = (events) => {
    return events.flatMap((item) => {
      const fileNamesArray = item.file_names.split(","); // Split filenames by comma
      return fileNamesArray.map((fileName) => ({
        id: item.itemID,
        img: `${item.base_url}${fileName.trim()}`, // Trim spaces & combine with base URL
      }));
    });
  };

  // ✅ Fix: Set the correct image index when opening the dialog
  const handleClickOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % itemData.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? itemData.length - 1 : prevIndex - 1
    );
  };

  const handleDownload = async () => {
    if (!eventItemData[currentIndex]) return;

    try {
      const response = await fetch(eventItemData[currentIndex].img);
      const blob = await response.blob();
      const blobURL = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobURL;
      link.download = `image_${currentIndex + 1}.jpg`; // Default filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up object URL
      URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!open) return; // Only listen when dialog is open

      if (event.key === "ArrowRight") {
        handleNext();
      } else if (event.key === "ArrowLeft") {
        handlePrevious();
      } else if (event.key === "Escape") {
        handleClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, currentIndex]); // Dependencies ensure effect runs only when needed

  // Sample events array with image and title data
  const galleries = [];

  const itemData = [
    {
      img: "https://images.unsplash.com/photo-1549388604-817d15aa0110",
      title: "Bed",
    },
    {
      img: "https://images.unsplash.com/photo-1525097487452-6278ff080c31",
      title: "Books",
    },
    {
      img: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
      title: "Sink",
    },
  ];

  return (
    <React.Fragment>
      {!isLargeScreen ? (
        <div className="gallery-list">
          <div>
            <ImageList
              cols={3}
              sx={{
                padding: "20px",
              }}
            >
              {itemData.map((item) => (
                <ImageListItem
                  key={item.img}
                  onClick={() => handleClickOpen(item.img)}
                >
                  <img
                    srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                    alt={item.title}
                    loading="lazy"
                    style={{ cursor: "pointer" }}
                  />
                </ImageListItem>
              ))}
            </ImageList>

            {/* Dialog to show the enlarged image */}
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
              <DialogContent>
                <img
                  src={selectedImg}
                  alt="Enlarged"
                  style={{ width: "100%", height: "auto" }}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                {/* Download Button */}
                {/* <Button
                  component="a"
                  href={selectedImg}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  variant="contained"
                >
                  Download
                </Button> */}
              </DialogActions>
            </Dialog>
          </div>
        </div>
      ) : (
        <div className="gallery-list">
          {/* back button */}
          <div>
            <ArrowBackIosIcon
              className="logo"
              onClick={() => navigate(-1)}
              label="BACK"
            />
            <b>BACK</b>
          </div>
          {/* event selection */}
          <div>
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                fontSize: "25px",
                fontWeight: "bold",
              }}
            >
              {title}
            </span>
          </div>
          <div>
            {eventItemData.length > 0 ? (
              <ImageList variant="masonry" cols={3} sx={{ padding: "20px" }}>
                {eventItemData.map((item, index) => (
                  <ImageListItem
                    key={index}
                    onClick={() => handleClickOpen(index)}
                  >
                    <img
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      alt={`Image ${index + 1}`}
                      loading="lazy"
                      // style={{ cursor: "pointer" }}
                      onContextMenu={(e) => e.preventDefault()}
                      onDragStart={(e) => e.preventDefault()}
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            ) : (
              <Typography
                variant="h6"
                align="center"
                sx={{ padding: "20px", color: "gray" }}
              >
                No photos to be shown at the moment. Please check again later.
              </Typography>
            )}

            {/* Image Preview Dialog with Navigation */}
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
              <DialogContent sx={{ position: "relative", textAlign: "center" }}>
                {/* Display current image */}
                {eventItemData.length > 0 && (
                  <img
                    src={eventItemData[currentIndex]?.img}
                    alt={`Image ${currentIndex + 1}`}
                    style={{ maxWidth: "100%", maxHeight: "80vh" }}
                    onContextMenu={(e) => e.preventDefault()}
                    onDragStart={(e) => e.preventDefault()}
                  />
                )}

                {/* Previous Button */}
                <IconButton
                  onClick={handlePrevious}
                  sx={{
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    color: "white",
                  }}
                >
                  <ArrowBack fontSize="large" />
                </IconButton>

                {/* Next Button */}
                <IconButton
                  onClick={handleNext}
                  sx={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    color: "white",
                  }}
                >
                  <ArrowForward fontSize="large" />
                </IconButton>

                {/* Download Button */}
                {/* <IconButton
                  onClick={handleDownload}
                  sx={{
                    position: "absolute",
                    bottom: 10,
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                  }}
                >
                  <Download />
                </IconButton> */}

                {/* Close Button */}
                <IconButton
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    color: "white",
                  }}
                >
                  <Close fontSize="large" />
                </IconButton>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default EventGallery;
